import React from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  label: string;
  icon: any;
  onClick?: () => void;
}

const useStyles = createUseStyles({
  root: {
    padding: '7px 20px',
    color: '#6c757d',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: '#272e37',
      textDecoration: 'none',
      backgroundColor: '#f8f9fa',
    },
  },
  icon: {
    marginRight: '.375rem',
  },
});

const ProfileMenuItem: React.FC<Props> = ({ label, icon: Icon, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.root} onClick={onClick}>
      <Icon className={classes.icon} size={16} /> {label}
    </div>
  );
};

export default ProfileMenuItem;
